import { useState } from 'react';
import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';

import Button, {
  Props as ButtonProps,
} from '@sorare/core/src/atoms/buttons/Button';
import Snackbar from '@sorare/core/src/atoms/snackbar/Snackbar';
import { FOOTBALL_PLAY_RIVALS_MY_SQUAD_INVITE_JOINSECRET_USERSLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import useCopyToClipboard from '@sorare/core/src/hooks/useCopyToClipboard';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = { joinSecret: string } & Omit<ButtonProps, 'onClick'>;
export const ShareInviteSquadButton = ({ joinSecret, ...rest }: Props) => {
  const [copiedSnackbarOpen, setCopiedSnackbarOpen] = useState(false);
  const { currentUser } = useCurrentUserContext();
  const copyToClipboard = useCopyToClipboard();
  const { formatMessage } = useIntl();

  if (!currentUser) return null;

  const onCopyLink = () => {
    copyToClipboard(
      `${formatMessage({
        id: 'Squad.InviteDialog.inviteMessage',
        defaultMessage: 'Join my Squad on Sorare!',
      })} ${window.origin}${generatePath(
        FOOTBALL_PLAY_RIVALS_MY_SQUAD_INVITE_JOINSECRET_USERSLUG,
        {
          joinSecret,
          userSlug: currentUser.slug,
        }
      )}`
    );
    setCopiedSnackbarOpen(true);
  };

  return (
    <>
      <Button {...rest} onClick={onCopyLink} />
      <Snackbar
        autoHideDuration={2000}
        open={copiedSnackbarOpen}
        onClose={() => {
          setCopiedSnackbarOpen(false);
        }}
        message={formatMessage(glossary.copiedToClipboard)}
      />
    </>
  );
};
